// extracted by mini-css-extract-plugin
export var container = "SubscriptionForm-module--container--39c02";
export var form = "SubscriptionForm-module--form--97d90";
export var header = "SubscriptionForm-module--header--9e924";
export var illustration = "SubscriptionForm-module--illustration--986e7";
export var input = "SubscriptionForm-module--input--01e35";
export var inputWrapper = "SubscriptionForm-module--inputWrapper--52838";
export var root = "SubscriptionForm-module--root--87fa6";
export var wavesLeft = "SubscriptionForm-module--wavesLeft--67e3f";
export var wavesRight = "SubscriptionForm-module--wavesRight--b127a";